import ErrorMessage from 'components/ErrorMessage/styled';

export default ErrorMessage;
